import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { RouterStateService } from './router-state.service';

declare const Intercom: any;

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  constructor(private routerState: RouterStateService, private authService: AuthService) {
    this.listenForLoggedIn();
    this.listenToRouterStateChanges();
  }

  public show() {
    if (hasIntercom()) {
      Intercom('show');
    }
  }

  public showMessages() {
    if (hasIntercom()) {
      Intercom('showMessages');
    }
  }

  public showNewMessage() {
    if (hasIntercom()) {
      Intercom('showNewMessage');
    }
  }

  private listenToRouterStateChanges() {
    this.routerState.routerState$
      .pipe(
        map((state) => state.url),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        if (hasIntercom()) {
          Intercom('update');
        }
      });
  }

  private listenForLoggedIn() {
    this.authService.isLoggedIn$.pipe(distinctUntilChanged()).subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.boot();
      } else {
        this.shutdown();
      }
    });
  }

  private async boot() {
    const user = await this.authService.userInfo$
      .pipe(
        filter((u) => !!u && !!u.id),
        take(1),
      )
      .toPromise();
    if (user && user.id && hasIntercom()) {
      const intercomSettings = {
        app_id: environment.intercomId,
        name: user.driverName,
        phone: user.phoneNumber,
        subcontractor_id: user.companyId,
        subcontractor_name: user.companyName,
        user_id: user.id,
        created_at: new Date(user.verifiedTimestamp),
        hide_default_launcher: true,
      };
      Intercom('boot', intercomSettings);
    }
  }

  private shutdown() {
    if (hasIntercom()) {
      Intercom('shutdown');
    }
  }
}

function hasIntercom() {
  return typeof Intercom !== 'undefined';
}
